import * as React from "react";
import { hydrate } from "react-dom";
import { App } from "../components/App";

const NODE_ID = "root";

let node = document.getElementById(NODE_ID);

if (!node) {
  node = document.body.appendChild(document.createElement("div"));
  node.id = NODE_ID;
}

try {
  hydrate(
    window.oetal.ssr.done ? (
      <App {...window.oetal.pageData as any}>
        {window.oetal.apps.map(({ name, component: TalApp }, i) => (
          <TalApp {...window.oetal.config[name]} key={i} />
        ))}
      </App>
    ) : (
      <App {...window.oetal.pageData as any} />
    ),
    node
  );
} catch (error) {
  console.error("There was an error mounting the application", error);
}
